import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from './../../services/common.service';
import { UserService } from './../../services/user.service';

import { EncrDecrService } from './../../services/encr-decr.service';

@Component({
  selector: 'app-s-add-user',
  templateUrl: './s-add-user.component.html',
  styleUrls: ['./s-add-user.component.css']
})
export class SAddUserComponent implements OnInit {
  user_id: any = 0;
  company_id: any = 0;
  APIKEY: any = 0;
  editUserForm: FormGroup;
  submitted = false;

  edit_userid: number = 0;
  customer_list_event: boolean = false;
  selectedItems: any[];
  customer_per: string;
  dropdownSettings: {};
  dropdownList: any[];
  roles: any;

  constructor(private formBuilder: FormBuilder,
    private _User: UserService,
    private toastr: ToastrService,
    private _router: Router,
    private _Common: CommonService,
    private EncrDecr: EncrDecrService,
    private _activatedroute: ActivatedRoute,) { }

  ngOnInit() {
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');

    this.setFormValue();
    this._activatedroute.params.subscribe(params => {
      this.edit_userid = params['id'];
    });
    const data = {
      APIKEY: this.APIKEY,
      edit_userid: this.edit_userid,
      company_id: this.company_id,
    }

    // this._User.getUserInfo(data)
    //   .subscribe(res => {
    //     this.editUserForm.setValue(res.data);
    //     // this.editUserForm.get('first_name').setValue(res.data.first_name);
    //     //this.editUserForm.get('first_name').setValue(res.data.first_name);
    //     //this.editUserForm.get('first_name').setValue(res.data.first_name);
    //   });
    this.getCustomerListDrop();
    this.getCustomerListadmin({ user_id: this.user_id, APIKEY: this.APIKEY }, 'normal');
    const roledata = {
      APIKEY: this.APIKEY,
      company_id: this.company_id,
    }

    this._User.getrolesadmin(roledata)
      .subscribe(
        res => {
          if (res.status == true) {
            this.roles = res.data;
          }
        },
      )

  }


  setFormValue() {
    this.editUserForm = this.formBuilder.group({
      first_name: ['', Validators.required],
      last_name: [''],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      phone: [''],
      alter_phone: [''],
      role: ['2'],
      customer_list: [''],
      note: [''],
      id: ['0'],
    });
  }

  //m//
  getCustomerListadmin(data, mode) {
    //new function by archana 
    this._Common.getCustomerListsuperadminforCustomer(data)
      .subscribe(
        res => {
          if (mode == 'custper') {
            this.selectedItems = res.data;
          }
          this.dropdownList = res.data;
          // console.log(res.data);
        },
      );
  }

  public onChange(event): void {
    // event will give you full breif of action
    const newVal = event.target.value;
    if (newVal == '431') {
      this.customer_list_event = true;
    }
    else {
      this.customer_list_event = false;
    }

  }
  getCustomerListDrop() {
    this.dropdownSettings = {
      singleSelection: false,
      enableCheckAll: false,
      idField: 'c_id',
      textField: 'company_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
  }

  onItemSelect(item: any) {
    // console.log(this.selectedItems);
  }
  onSelectAll(items: any) {
    // console.log(items);
  }


  public onCustomerPer(value: boolean) {
    if (value != true) {
      this.selectedItems = [];
      this.customer_per = '';
    }
    else {
      const data = {
        APIKEY: this.APIKEY,
        company_id: this.company_id,
      }
      const mode = 'custper';
      this.getCustomerListadmin(data, mode);
      this.customer_per = 'all';
    }
  }

  //m//


  // convenience getter for easy access to form fields
  get f() { return this.editUserForm.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.editUserForm.invalid) {
      return;
    }

    //alert('SUCCESS!! :-)')
    const formData = new FormData();
    formData.append('first_name', this.editUserForm.get('first_name').value);
    formData.append('last_name', this.editUserForm.get('last_name').value);
    formData.append('email', this.editUserForm.get('email').value);
    formData.append('password', this.EncrDecr.set(localStorage.getItem('key'), this.editUserForm.get('password').value));
    // formData.append('password', this.editUserForm.get('password').value);
    formData.append('phone', this.editUserForm.get('phone').value);
    formData.append('alter_phone', this.editUserForm.get('alter_phone').value);
    formData.append('note', this.editUserForm.get('note').value);
    formData.append('id', this.editUserForm.get('id').value);
    // formData.append('customer_list', this.editUserForm.get('customer_list').value);
    formData.append('role', this.editUserForm.get('role').value);
    formData.append('user_id', this.user_id);
    formData.append('company_id', this.company_id);
    formData.append('APIKEY', this.APIKEY);
    formData.append('customer_list', JSON.stringify(this.selectedItems));

    //console.log(formData);return false;

    this._User.addUser(formData).subscribe(
      res => {
        if (res.status == true) {
          this.toastr.success(res.message, 'Success');
          //this. ngOnInit();
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/super-admin/user-list/active');
          });

        }
        else {
          this.toastr.error(res.message, 'Error');
        }
      }
    );



  }


}
